import { PageHeader } from '../../components/PageHeader';
import { AdminBreadcrumbs } from '../../components/AdminBreadcrumbs';
import { useT } from '../../locales';
import { UsersTable } from './components/UsersTable';

export function UsersListPage() {
  const t = useT();

  return (
    <div>
      <PageHeader
        breadcrumb={<AdminBreadcrumbs current={t('pages.users.title')} />}
        title={t('pages.users.title')}
        subtitle={t('pages.users.subtitle')}
      />
      <UsersTable />
    </div>
  );
}
